import { createApp } from 'vue';
import { createPinia } from 'pinia';
import VueToast from 'vue-toast-notification';
import { Log } from 'oidc-client-ts';
import { I18n } from 'vue-i18n';
import { i18n } from './lang';
import router from './routes';

import 'vue-toast-notification/dist/theme-default.css';

import App from './App.vue';
import './assets/scss/application.scss';
import { tooltipDirective } from './components/utils';
import utils from './components/vue-context';

Log.setLogger(console);
Log.setLevel(import.meta.env.PROD ? Log.WARN : Log.INFO);

window.VIDEOJS_NO_DYNAMIC_STYLE = true;

const pinia = createPinia();

// initialize app
createApp(App)
  .use(i18n) // first - locale must be resolved asap
  .use(router)
  .use(utils, { router, i18n: i18n as I18n })
  .use(pinia)
  .use(VueToast, { position: 'bottom-left' }) // https://www.npmjs.com/package/vue-toast-notification
  .directive('tooltip', tooltipDirective)
  .mount('#app');

declare global {
  interface Window {
    APP_CONFIG: ApplicationConfig; // app config loaded externally
    tokenChecked: boolean; // true if the token was checked for validity
    VIDEOJS_NO_DYNAMIC_STYLE: boolean; // Disabling Additional <style> Elements (https://videojs.com/guides/skins/)
  }
}

/**
 * app config loaded externally
 */
interface ApplicationConfig {
  oauth: Record<string, string>,
  legal: Record<string, Record<string, string>>,
  roles: {
    show: boolean,
    onlyBusinessTypes?: string[], //todo use BusinessType[],
  }
  axios: {
    default_timeout: number,
  },
  crm: {
    userLink: string,
    cdh_contacts_top: number,
  },
  apps: {
    showLink: boolean,
  },
  sync: {
    // list of countries to set syncFlag automatically; format: ISO3; example: ["DEU", "BRA"]
    auto4countries: string[],
  }
}
